/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CReferralMode {
    CODES = 'Codes',
    BASKET = 'Basket',
}
